// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1Kx3M","title":"styles_title___mG8W"};